/* React hooks */
import {useState} from "react";
/* Components */
import FormFunerariumGeneralInfos from "../../../forms/funerarium/FormFunerariumGeneralInfos";
import useData from "../../../hooks/useData";
import Icon from "../../../components/common/Icon";


export default function ViewFunerariumGeneralInfos({ apiFunerariumGeneralInfos, legend }) {
    const { funerariumInfos } = useData();
    const [ showModal, setShowModal ] = useState(false);

    const handleFormGeneralFunerarium = () => {
        setShowModal(true);
    }

    return (
        <>
            { showModal &&
                <div className="modal funerarium-infos">
                    <FormFunerariumGeneralInfos apiFunerariumGeneralInfos={apiFunerariumGeneralInfos} setShowModal={setShowModal} legend="Modification des informations du funérarium"/>
                </div>
            }
            <fieldset>

                <Icon span={legend} source="fa fa-house"/>
                <div className="form-input">
                    <label htmlFor="name">Nom du lieu</label>
                    <span>{funerariumInfos?.name}</span>
                </div>
                <div className="form-input">
                    <label htmlFor="surname">Intitulé du funérarium</label>
                    <span>{funerariumInfos?.surname}</span>
                </div>
                <div className="form-input">
                    <label htmlFor="phone">Utiliser l'adresse de l'agence ?</label>
                    <span>{funerariumInfos?.useAgencyAddress ? "Oui" : "Non"}</span>
                </div>
                <div className="buttons-container">
                    <button type="button" className="red-button" onClick={handleFormGeneralFunerarium}>
                        <i className="fa fa-pen"/><span>Modifier les informations</span>
                    </button>
                </div>
            </fieldset>
        </>

    )
}

